module.exports = __webpack_public_path__ + "img/horizontal_3_7_5010.cf1421f2.png";